export default __webpack_public_path__ + "static/1-094bdcaa733b56328818a7df18fb1bea.jpeg";